import { PreviousExitDetails } from '../types';

/**
 * Extracts company ID from previousExitDetails
 */
export const getCompanyIdFromPrevious = (
  previousExitDetails: PreviousExitDetails | undefined,
  isEditMode: boolean,
) => {
  if (!isEditMode || !previousExitDetails?.selectedCompany) return undefined;
  return previousExitDetails.selectedCompany._id;
};
